/* (ignored) */


//////////////////
// WEBPACK FOOTER
// url (ignored)
// module id = 377
// module chunks = 1